import { render, staticRenderFns } from "./BiddingRoom.vue?vue&type=template&id=038ca7f8&scoped=true"
import script from "./BiddingRoom.vue?vue&type=script&lang=js"
export * from "./BiddingRoom.vue?vue&type=script&lang=js"
import style0 from "./BiddingRoom.vue?vue&type=style&index=0&id=038ca7f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038ca7f8",
  null
  
)

export default component.exports